import moment from "moment";
import { UP_SELL_QUERY_TOKEN } from "../actions/upSellActions";
import {
  MFA_LOADING,
  SET_MFA_COUNTS,
  SET_MFA_STATS,
  ADD_MFA_ERROR,
  RESET_REPORTS,
} from "../constants";
import mapColorsToLabels from "../../utils/mapColorsToLabel";

let SAVED_STATE = JSON.parse(sessionStorage.getItem(UP_SELL_QUERY_TOKEN));
if (SAVED_STATE && moment().isAfter(SAVED_STATE.expires_at)) {
  SAVED_STATE = null;
}

const initial_state = {
  errors: {},
  loading: {},

  // User selected options
  options: {
    startDateTime: moment().subtract(1, "day").startOf("day"), // Default: start of yesterday
    endDateTime: moment().endOf("day"), // Default: through today
    expires_at: moment().add(1, "hour").toJSON(),
    ...SAVED_STATE,
  },

  // Display Data based on selections above
  sent: [
    /* {type_vch: String, subtype_vch: String, count: Number}, ... */
  ],
  totals: {
    /*  received: Number, email: Number,  sms: Number, voice: number, total: number */
  },
  stats: {
    /* email: [{ dispatched: Number, delivered: Number, ...}, sms: [{...}] */
  },
};

export default function (state = initial_state, { type, payload, name }) {
  let { loading, errors } = state;

  switch (type) {
    case MFA_LOADING:
      loading[payload] = true;

      return {
        ...state,
        loading: { ...loading },
      };

    case ADD_MFA_ERROR: // If provided, clear loading
      name && (loading[name] = false);

      if (payload.message) {
        payload = {
          [name]: "There was a problem. Please try again later",
        };
      }

      errors = {
        ...errors,
        ...payload,
      };
      return {
        ...state,
        errors,
        loading: { ...loading },
      };

    case SET_MFA_COUNTS:
      loading["counts"] = false;
      delete errors["counts"]; // clear previous errors

      return {
        ...state,
        errors: { ...errors },
        loading: { ...loading },
        sent: payload.sent || [],
        totals: payload.totals || {},
      };

    case SET_MFA_STATS:
      loading["stats"] = false;
      delete errors["stats"]; // clear previous errors

      Object.values(payload).forEach((statuses) => {
        mapColorsToLabels(statuses.map(({ status }) => status));
      });

      return {
        ...state,
        errors: { ...errors },
        loading: { ...loading },
        stats: payload || {},
      };

    case RESET_REPORTS:
      return { ...initial_state };

    default:
      return state;
  }
}
